// src/pages/Profile/components.js
import React from 'react';
import { useApp } from '../../context/AppContext';
import ProfileMenuItem from '../../components/ui/ProfileMenuItem';
import { 
  UserIcon, 
  CalendarIcon, 
  BellIcon, 
  CreditCardIcon, 
  MapPinIcon, 
  SearchIcon, 
  ArrowLeftIcon,
  ChevronRightIcon,
  HeartIcon,
  StarIcon
} from '../../components/common/Icons';

// Profile Screen component
export const ProfileScreen = () => {
  const { navigateTo } = useApp();
  
  return (
    <div className="flex-1 overflow-y-auto pb-16">
      <div className="p-4 bg-gray-100 flex flex-col items-center">
        <div className="w-24 h-24 bg-gray-300 rounded-full flex items-center justify-center text-3xl text-gray-600 mb-4">
          FC
        </div>
        <h1 className="text-2xl font-bold">Florin Craciun</h1>
      </div>
      
      <div className="mt-4">
        <ProfileMenuItem 
          icon={<UserIcon size={20} />}
          title="Detalii cont"
          onClick={() => {}}
        />
        <ProfileMenuItem 
          icon={<CalendarIcon size={20} />}
          title="Programări"
          onClick={() => navigateTo('appointments')}
        />
        <ProfileMenuItem 
          icon={<BellIcon size={20} />}
          title="Notificări"
          badge={3}
          onClick={() => navigateTo('notifications')}
        />
        <ProfileMenuItem 
          icon={<BellIcon size={20} />}
          title="Setări notificări"
          onClick={() => {}}
        />
      </div>
      
      <div className="mt-4 border-t">
        <ProfileMenuItem 
          icon={<ArrowLeftIcon size={20} />}
          title="Ieși din cont"
          onClick={() => {}}
        />
      </div>
    </div>
  );
};

// Favorites Screen component
export const FavoritesScreen = () => {
  return (
    <div className="flex-1 overflow-y-auto pb-16 bg-white">
      <div className="flex flex-col items-center justify-center h-full p-4 text-center">
        <div className="mb-4">
          <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
            <HeartIcon size={30} className="text-red-500" />
          </div>
          <h2 className="text-2xl font-bold mb-2">Favorite</h2>
          <p className="text-gray-600 mb-6">Paginile salvate de tine în lista de favorite vor apărea aici</p>
          <button className="bg-blue-600 text-white rounded-full py-3 px-6">
            Caută serviciu sau specialist
          </button>
        </div>
      </div>
    </div>
  );
};

// Appointments Screen component
export const AppointmentsScreen = () => {
  const { navigateTo } = useApp();
  
  // Exemple de programări
  const appointments = [
    {
      id: 1,
      status: 'FINALIZAT',
      date: 'Sâ. 15 feb.',
      time: '14:45',
      service: 'Tuns',
      salon: 'Frizerie cu Stil și Coafor Focșani',
      specialist: 'Eugen Ciprian Grigore',
      duration: '45 min',
      price: '60 lei',
      location: {
        address: 'Bulevardul Brăilei nr 102 (Parcare Kaufland), Focșani',
        phone: '0765 407 582'
      }
    },
    {
      id: 2,
      status: 'FINALIZAT',
      date: 'Lu. 9 dec.',
      time: '13:10',
      service: 'Tuns skin fade',
      salon: 'Frizerie cu Stil și Coafor Focșani',
      specialist: 'Eugen Ciprian Grigore',
      duration: '40 min',
      price: '50 lei',
      location: {
        address: 'Bulevardul Brăilei nr 102 (Parcare Kaufland), Focșani',
        phone: '0765 407 582'
      }
    },
    {
      id: 3,
      status: 'FINALIZAT',
      date: 'Sâ. 7 dec.',
      time: '17:20',
      service: 'Tuns skin fade',
      salon: 'Frizerie cu Stil și Coafor Focșani',
      specialist: 'Eugen Ciprian Grigore',
      duration: '40 min',
      price: '50 lei',
      rating: 5,
      location: {
        address: 'Bulevardul Brăilei nr 102 (Parcare Kaufland), Focșani',
        phone: '0765 407 582'
      }
    }
  ];
  
  const handleAppointmentClick = (appointment) => {
    // Salvăm programarea selectată în context și navigăm la detalii
    navigateTo('appointmentDetails', { appointment });
  };
  
  return (
    <div className="flex-1 overflow-y-auto pb-16">
      <header className="p-4 bg-white border-b">
        <h1 className="text-2xl font-bold">Programări</h1>
      </header>
      
      <section className="p-4">
        <h2 className="text-lg font-bold mb-4">În trecut</h2>
        
        <div className="space-y-4">
          {appointments.map(appointment => (
            <div key={appointment.id} className="bg-white rounded-lg shadow overflow-hidden">
              <div className="p-3 border-b bg-gray-50">
                <div className="font-bold uppercase">{appointment.status}</div>
                <div className="text-lg font-bold">{appointment.date}</div>
              </div>
              <div className="p-4">
                <h3 className="font-bold">{appointment.service}</h3>
                <p className="text-gray-600">{appointment.specialist} - {appointment.salon}</p>
                <p className="text-gray-500 mt-1">{appointment.time} ({appointment.duration})</p>
                <div className="flex justify-between mt-2">
                  <span className="font-bold">{appointment.price}</span>
                  <div className="flex items-center">
                    {appointment.rating && (
                      <div className="flex mr-2">
                        {Array(5).fill(0).map((_, i) => (
                          <StarIcon key={i} size={16} fill="#FFD700" stroke="#FFD700" />
                        ))}
                      </div>
                    )}
                    <button 
                      className="text-blue-600"
                      onClick={() => handleAppointmentClick(appointment)}
                    >
                      <ChevronRightIcon size={20} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};